module.exports = __webpack_public_path__ + "img/Sib_Mus_4kl.c5188ccc.jpg";